import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propShape, propFunc, } from '../../../../../../helpers/custom-prop-types';
import SlideSearchShareStatusTab from '../../../../../Ui/SlideSearch/ShareStatusTab';
/**
 * 共有状況を表示する
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const ProfessionalMyPageTopProffitSearchShare = (props) => {
    const { onClickItem, receive, share } = props;
    return (_jsx("div", Object.assign({ className: 'professional_mypage_top_proffit_search_share' }, { children: _jsx(SlideSearchShareStatusTab, { className: 'share_tab', onClickItem: onClickItem, receive: receive, share: share }) })));
};
ProfessionalMyPageTopProffitSearchShare.propTypes = {
    onClickItem: propFunc(),
    receive: propShape().isRequired,
    share: propShape().isRequired,
};
ProfessionalMyPageTopProffitSearchShare.defaultProps = {
    onClickItem: undefined,
};
export default ProfessionalMyPageTopProffitSearchShare;
